import style from "./section.module.css";
import MarkdownDisplay from "../../../../../Common/MarkdownDisplay/MarkdownDisplay.tsx";
import Tooltip from "../../../../../Common/Tooltips/Tooltip/Tooltip.tsx";

export interface SectionData {
  title?: string;
  before?: string;
  tag?: string;
  text: string;
  id: number;
  header?: boolean;
  saveFunc: (text: string) => void;

  isCvss?: boolean;
}
interface Props {
  data: SectionData;
  selectFun: (data: SectionData) => void;
}

function Section({ data, selectFun }: Readonly<Props>) {
  function selectSection() {
    selectFun(data);
  }

  function stopPropagation(event: React.MouseEvent) {
    event.stopPropagation(); // Prevent click propagation to the button
  }

  const text = data.before ? data.before + data.text : data.text;

  return (
    <button className={style.sectionWrapper} onClick={selectSection}>
      <div>
        {data.title ? (
          <h5 className={style.sectionHeader}>
            <span>{data.title}</span>
          </h5>
        ) : null}
        <MarkdownDisplay value={text} header={data.header} />
      </div>
      {data.tag && (
        <Tooltip
          trigger={
            <div
              className={style.vulnTag}
              onClick={stopPropagation}
              style={{ userSelect: "text", maxWidth: "300px" }}
            >
              {data.tag}
            </div>
          }
          description={data.tag}
          showArrow
          highContrast
        />
      )}
    </button>
  );
}

export default Section;
